import { useEffect } from "react";
import { Toolbar } from "../toolbar/toolbar";
import { fetchCourses } from "../redux/courseSlice";
import store from "../redux/store";
import { useSelector } from "react-redux";
import MediaCard from "../home/course-item";

export const CoursesScreen = () => {
  useEffect(() => {
    store.dispatch(fetchCourses());
  }, []);

  const { courses } = useSelector((state) => state.courseSlice);

  return (
    <div className="">
      <Toolbar />
      <div className="mt-20 overflow-hidden ">
        <div className=" relative w-full z-[2] flex flex-wrap justify-center  ">
          {courses.map(
            ({
              title,
              description,
              courseId,
              thumbnail,
              totalDuration,
              courseDurationPriceResponse,
              courseListStatus,
            }) => {
              return courseListStatus ? (
                <MediaCard
                  totalDuration={totalDuration}
                  courseDurationPriceResponse={courseDurationPriceResponse}
                  title={title}
                  thumbnail={thumbnail}
                  description={description}
                  courseId={courseId}
                />
              ) : null;
            }
          )}
        </div>
      </div>
    </div>
  );
};
